export default __webpack_public_path__ + "11b9ea0db08a932206d24111067c3e51.svg";